module.exports = __webpack_public_path__ + "img/art6-img2.16b3ad52.jpeg";